import React, { useState } from 'react';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import UI_ACTIONS from '../../data/UiActionConstants';
import UiAction from '../../components/UiAction';
import ListingPageComponent from '../../components/ListingPageComponent.js';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare } from "@fortawesome/free-solid-svg-icons";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { getApi } from '../../api/endpoints.js';
import { useNavigate } from 'react-router-dom';
import FiltersPartial from "./FiltersPartial.js";


const Index = (props) => {
  const defaultHeaderConfig = { disableSort: true };
  const navigate = useNavigate();
  const [filtersModel, setFiltersModel] = useState({})

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'Customer | Base Customer',
      value: (row) => {
        return <div><span>{row.cus_nomenclature_id} <br/> {row.base_customer_nomenclature_id ? `(${row.base_customer_nomenclature_id})` : ""} <br/> {row.booking_service_center_id}</span></div>
      },
    },
    {
      ...defaultHeaderConfig,
      label: 'Name',
      value: (row) =>{
        return <>
          <span>{row.kyc_validated && <FontAwesomeIcon style={{color: "green"}} icon={faCheckSquare}/>}</span> &ensp;
          <span>{row.name}</span>
        </>
      }
    },
    {
      ...defaultHeaderConfig,
      label: 'Mobile Number',
      attr: 'mobile_number',
    },
    {
      ...defaultHeaderConfig,
      label: 'Details',
      value: (row) => {
        return <div>
          <span> {row.rental_booking_id && `Booking Id:${row.rental_booking_id}`} &ensp; <br/> 
            {row.vehicle_serial_number && `Vehicle: ${row.vehicle_serial_number}`}
          </span>
        </div>
      },
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_rental_customer.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e) => onEditClick(row.id)}>
              <FontAwesomeIcon icon={faEye} />
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  const onEditClick = (id) => {
    navigate(`/rental_customers/${id}`)
  }

  return <>
    <ListingPageComponent
      key={PAGES.RentalCustomersPage.name}
      uiPage={uiManager.getUiPage(PAGES.RentalCustomersPage.name)}
      breadcrumbs={[{ label: 'Home', url: '/dashboard' }, { label: 'Rental Customers' }]}
      listingMutation={getApi('rental_customers')}
      className="rental-customer-listing-page"
      contentHeading="Rental Customer List - Results"
      headers={headers}
      recordsKey="rental_customers"
      filtersModel={filtersModel}
      filters={
        <FiltersPartial
          filtersModel={filtersModel}
          setFiltersModel={setFiltersModel}
        />
      }
      searchBy={['Customer ID', 'Mobile Number', 'Vehicle Serial Number']}
    />
  </>
}

export default Index;
